module.exports = __webpack_public_path__ + "static/media/ic-search.87eb6695.svg";